import BasicInfoModel from '../model/BasicInfo';
import CouponModel from '../model/Coupon';
import HairuoRequest from '../lib/request/Hairuo';
import {isEmpty, pick} from 'lodash';
import {get as getCookie, set as setCookie} from '../lib/cookie';
import {
    getRedirectUrl
    // getRouteQuery
} from '@/common/util';

/**
 * 使用Hairuo请求对象创建新的请求对象
 *
 * @param {Object} [hairuo={}] - 请求配置项
 * @returns {HairuoRequest} 返回一个Hairuo请求对象
 * @throws {Error} 如果参数为空，抛出错误信息'hairuo config is required'
 */
function hairuoRequest(hairuo = {}) {
    if (isEmpty(hairuo)) {
        throw new Error('hairuo config is required');
    }
    const {toPath} = hairuo;
    delete hairuo.toPath;
    return new HairuoRequest({
        ...hairuo,
        onredirect: () => {
            const {userid, optid} = hairuo;
            const lastKey = `aigc-reload-${userid}-${optid}`;
            const nowTime = new Date().getTime();
            // 30s
            const timeSpan = 15000;
            if (userid && optid) {
                // 取出cookie
                const lastReloadTime = getCookie(lastKey);
                if (lastReloadTime && (nowTime - lastReloadTime) < timeSpan) {
                    // 如果距上次重加载不超过30s，则不再执行动作，避免重复循环
                    console.log('停在这了');
                    return;
                }
            }
            // 如果不是首页，且没有近一分钟内的刷新记录，则重定向
            let pathname = toPath || window.location.pathname;
            const docPages = [
                '/userCenter/aboutUs'
            ];
            const isDoc = docPages.includes(pathname);
            // 不要求登录的页面，不要强制跳转login页面
            if (hairuo.allowNotLogin) {
                console.log('allowNotLogin');
                return false;
            }
            if (pathname.indexOf('mobile') < 0
                && pathname.indexOf('co-extension-plan') < 0
                && pathname.indexOf('helpDoc') < 0
                && pathname.indexOf('login') < 0
                && !isDoc) {
                // 触发登录的时候，才写入cookie
                setCookie(lastKey, nowTime, {
                    expires: new Date(nowTime + timeSpan),
                    path: '/',
                    domain: window.location.hostname,
                    secure: false
                });
                console.log('app redir', pathname, window.location.search);
                console.log(getRedirectUrl(pathname + window.location.search));
                console.log(getRedirectUrl(window.location.href));
                if (process.env.VUE_APP_VERSION === 'offline') {
                    // alert('test login before redirect');
                }
                window.location.href = getRedirectUrl(window.location.href);
                // window.location.href = `${window.location.origin}/login`;
            }
        },
        onerror: err => {
            let data = pick(err, ['name', 'message', 'stack']);
            if (err.config) {
                let {url, baseURL, method, data: body} = err.config;
                if (body.length > 256) {
                    body = body.substring(0, 256) + '...';
                }
                data.request = {url: baseURL + url, method, body};
            }
        }
    });
}
function basicInfoModel(hairuo) {
    return new BasicInfoModel({
        request: hairuoRequest(hairuo)
    });
};
/**
 * 创建优惠券模型实例
 *
 * @param {Object} hairuo - Hairuo请求对象
 * @returns {CouponModel} 返回CouponModel类的实例
 */
function couponModel(hairuo) {
    return new CouponModel({
        request: hairuoRequest(hairuo)
    });
};
/**
 * 从数据库中加载登录信息
 *
 * @param hairuo - 当前 hairuo 对象实例
 * @returns {Promise<Object>} 包含登录信息的对象，包括 accountInfo、hags
 */
function loadLoginInfo(hairuo) {
    return basicInfoModel(hairuo).getBasicInfo(['hags', 'accountInfo'])
        .then(async result => {
            // ToDo Mark：临时方案：有1.0的权限，直接赋予2.0权限
            // 政企客户不能使用2.0
            // 真实的2.0客户独立记录下
            result.hags.real_qingduo_style_v2 = result.hags.qingduo_style_v2;
            if (result.hags.digital_human_list
                && !result.hags.digital_is_passport
            ) {
                result.hags.qingduo_style_v2 = result.hags.digital_human_list;
            }
            let basicInfo = {
                accountInfo: result.accountInfo || {},
                hags: result.hags || {}
            };
            if (!result.accountInfo?.userName) {
                return basicInfo;
            }
            // 判断是否外部用户的逻辑写在这里，其他地方不用单独计算，
            // 如果后期要修改外部用户的逻辑判定，只需要改一个地方即可.
            // 2.29版本逻辑：外部账户的定义：pass+UC无资质 https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/MUyZ7Y-BGz/VA_1DZ0wnN/FX9ndbnpZxcbt_
            const isOffline = process.env.VUE_APP_VERSION === 'offline';
            const isDev = process.env.VUE_APP_VERSION === 'dev';
            // pass一定会返回ucShadowType === 1， uc账户返回ucShadowType === 0或不返回ucShadowType
            let isUC = basicInfo.accountInfo?.ucShadowType !== 1;
            // 测试环境获取不到ucShadowType，所以这里根据测试账号名判断
            if (isOffline || isDev) {
                isUC = basicInfo.accountInfo?.userName !== '擎舵测试pass';
            }
            let hasUCLience = false;
            if (isUC) {
                hasUCLience = await basicInfoModel(hairuo).isUCLicence();
                // 如果是UC有资质，直接赋予1.0权限名单
                if (hasUCLience) {
                    basicInfo.hags.digital_human_list = true;
                }
                basicInfo.hags.is_qingduo_uc_user = true;
            }
            const data = {
                ...basicInfo,
                isUC,
                hasUCLience,
                isStyleV2: basicInfo.hags.qingduo_style_v2,
                isRealStyleV2: basicInfo.hags.real_qingduo_style_v2,
                isOuterUser: !isUC || !hasUCLience
            };
            return data;
        }).catch(err => {
            if (process.env.NODE_ENV === 'development') {
                console.log('load basic info fail', err);
            }
            throw err;
        });
}

function loadCouponInfo(hairuo) {
    // 获取点券信息和价格表
    return Promise.all([
        couponModel(hairuo).getCouponInfo(),
        couponModel(hairuo).getPriceList({spuTypeEnum: 'AI_GENERATE_SERVICE'})
    ]).then(result => {
        const [couponInfo, priceInfo] = result;
        return {
            couponInfo,
            priceInfo
        };
    });
}

export default {
    state: {
        loadingInfo: true,
        // 记录登录接口的错误
        errInfo: {},
        hairuo: {},
        userInfo: {
            'accountInfo': {},
            'bizHags': {}
        },
        couponInfo: {},
        priceInfo: {}
    },
    mutations: {
        SAVE_ERR_INFO: (state, data) => {
            state.errInfo = data;
        },
        SAVE_LODING_INFO: (state, data) => {
            state.loadingInfo = data;
        },
        SAVE_HAIRUO_INFO: (state, data) => {
            state.hairuo = data;
        },
        SAVE_USER_INFO: (state, data) => {
            state.loadingInfo = false;
            // TODO 小流量验证
            // data.hags.qingduo_image_ip_thumbnail_generate = false;
            state.userInfo = {
                accountInfo: data.accountInfo || {},
                isStyleV2: data.isStyleV2,
                isRealStyleV2: data.isRealStyleV2,
                isOuterUser: data.isOuterUser,
                isUC: data.isUC,
                hasUCLience: data.hasUCLience,
                bizHags: data.hags || {}
            };
        },
        SAVE_COUPON_INFO: (state, data) => {
            state.couponInfo = data;
        },
        SAVE_PRICE_INFO: (state, data) => {
            state.priceInfo = data;
        }
    },
    actions: {
        // loading
        async setLoading({commit}, result) {
            commit('SAVE_LODING_INFO', result);
        },
        // 存储用户信息
        async setUserInfo({commit}, result) {
            commit('SAVE_USER_INFO', result);
        },
        // 存储hairuo
        async saveHairuo({commit}, result) {
            commit('SAVE_HAIRUO_INFO', result);
        },
        // 读取用户信息
        async getUserInfo({commit}, payload) {
            commit('SAVE_LODING_INFO', true);
            commit('SAVE_HAIRUO_INFO', payload);
            commit('SAVE_ERR_INFO', null);
            let data;
            await loadLoginInfo(payload).then(result => {
                if (result) {
                    commit('SAVE_USER_INFO', result);
                    commit('SAVE_LODING_INFO', false);
                }
                data = result;
            }).catch(err => {
                commit('SAVE_ERR_INFO', err);
                data = err;
            });
            if (data.accountInfo?.userName) {
                // 获取点券和价格的动作不要阻塞基本信息动作
                loadCouponInfo(payload).then(result => {
                    commit('SAVE_COUPON_INFO', result.couponInfo);
                    commit('SAVE_PRICE_INFO', result.priceInfo);
                });
            }
            return data;
        },
        // 将查询点券和价格的动作独立成单独可调用的方法
        async getPriceInfo({commit}, payload) {
            loadCouponInfo(payload).then(result => {
                commit('SAVE_COUPON_INFO', result.couponInfo);
                commit('SAVE_PRICE_INFO', result.priceInfo);
            });
        },
        // 获取点券信息
        async getCouponInfo({commit}) {
            const hairuo = this.state.app.hairuo;
            const data = await couponModel(hairuo).getCouponInfo();
            commit('SAVE_COUPON_INFO', data);
        },
        async getTaskCenterInfo({commit}, param) {
            const hairuo = this.state.app.hairuo;
            const data = await basicInfoModel(hairuo).getTaskCenterInfo(param);
            return data;
        }
    },
    getters: {}
};
